import React, { useMemo, useState } from "react";
import MainPageDialog from "../../../components/dialog";
import ShareData from "../shareData";
import { toast } from "react-toastify";
import OrderRequestData from "../OrderRequestData";
import { defaultObj, toggleAttachDialogStateForLocationBase } from "../helper";
import { useForm } from "react-hook-form";
import baseApiHelper from "../../../services/baseApiHelper";
import { formattedDate } from "../../../helper";
import { cloneDeep } from "lodash";
const ShareDataFromSidePanel = ({
  openShareDataDialog,
  setOpenShareDataDialog,
  selectedChat,
  attachDocumentHandler,
  isLocationTab,
}) => {
  const { control, setValue, watch, handleSubmit } = useForm();
  let [shareDataArr, setShareDataArr] = useState({});
  const [filterShareData, setFilterShareData] = useState([]);
  const [openOrderRequestDialog, setOpenOrderRequestDialog] = useState(false);
  // const [openShareDataDialog,setOpenShareDataDialog]=useState(false)
  const submitHandler = (data) => {
    let isAnyDataSelected = false;
    Object?.keys(shareDataArr)?.map((shareDataKey) => {
      if (shareDataArr[shareDataKey]?.data?.length > 0) {
        shareDataArr[shareDataKey]?.data?.forEach((dataObj, k) => {
          if (dataObj?.checked) {
            isAnyDataSelected = true;
          }
        });
      }
    });
    if (!isLocationTab) {
      if (
        Object?.keys(shareDataArr)?.some((shareDataKey) => {
          return shareDataArr[shareDataKey]?.selectedData?.length > 0;
        })
      ) {
        isAnyDataSelected = true;
      }
    } else {
      if (
        Object?.keys(shareDataArr)?.some((shareDataKey) => {
          console.log(shareDataArr[shareDataKey]);
          return shareDataArr[shareDataKey]?.isChecked == true;
        })
      ) {
        isAnyDataSelected = true;
      }
    }

    if (!data?.patient?.length > 0 && !data?.all_patient && isLocationTab) {
      return toast.error("Please Select Patient");
    }
    if (!isAnyDataSelected) {
      return toast.error("No Data is Selected");
    }
    let obj = {
      ...shareDataArr,
      csv: data?.csv,
      appointment_csv: data?.appointment_csv,
    };
    if (isLocationTab) {
      obj.practice_id = selectedChat?.location?.id;
      obj.pid = data?.patient?.map((v) => v?.pid?.toString())?.join(",");
      obj.start_date =
        data.start_date && formattedDate(data.start_date, "YYYY-MM-DD");
      obj.end_date =
        data.end_date && formattedDate(data.end_date, "YYYY-MM-DD");
      obj.document_type = data?.document_type?.id;
      obj.all_patients = data?.all_patients ? 1 : 0;
    }
    setFilterShareData({
      ...obj,
    });
    setOpenOrderRequestDialog(true);
  };
  const resetHandler = () => {
    const resetData = cloneDeep(defaultObj);
    [
      "patient",
      "all_patient",
      "start_date",
      "end_date",
      "document_type",
      "ccm_summary",
      "acog_summary",
    ]?.map((v, k) => {
      setValue(v, "");
    });
    Object.keys(resetData)?.map((key) => {
      const obj = resetData[key]?.slug == "clinical_record" ? true : false;
      if (
        resetData[key]?.slug == "clinical_record" &&
        resetData[key]?.data?.length > 0
      ) {
        resetData[key]?.data?.map((obj) => {
          setValue(obj.slug, false);
          obj.checked = false;
        });
      } else {
        setValue(resetData[key]?.slug, false);
        resetData[key] = {
          ...resetData[key],
          selectedData: [],
          toggle: obj,
          checked: false,
        };
      }
    });
    if (isLocationTab) {
      setShareDataArr({
        filter: {
          title: "Filter",
          slug: "filter",
          toggle: true,
        },
        ...toggleAttachDialogStateForLocationBase(resetData, false),
      });
    } else {
      if (
        selectedChat?.patient?.ccm_status == "active" ||
        selectedChat?.patient?.ccm_status == "enrolled" ||
        selectedChat?.patient?.ccm_status == "paused"
      ) {
        resetData.clinicalRecord.data.push({
          title: "CCM Summary",
          slug: "ccm_summary",
          days: "all",
          checked: false,
        });
      }
      if (selectedChat.patient?.is_aco_patient) {
        resetData.clinicalRecord.data.push({
          title: "ACOG Report",
          slug: "acog_summary",
          days: "all",
          lab_ids: [],
          checked: false,
        });
      }
      setShareDataArr(resetData);
    }
  };

  const footerList = [
    {
      type: "cancel",
      action: () => {
        setOpenShareDataDialog(false);
      },

      title: "Cancel",
    },
    {
      type: "save",
      action: handleSubmit(submitHandler),
      title: "Process",
    },
    {
      type: "cancel",
      title: "Reset",
      action: () => {
        resetHandler();
      },
    },
  ];
  return (
    openShareDataDialog && (
      <MainPageDialog
        title="Share Data"
        contentCls="px-6"
        onCancelHandler={() => {
          setOpenShareDataDialog(false);
        }}
        footerList={footerList}
      >
        <>
          {openOrderRequestDialog && (
            <OrderRequestData
              selectedChat={selectedChat}
              resetHandler={resetHandler}
              setOpenOrderRequestDialog={setOpenOrderRequestDialog}
              openOrderRequestDialog={openOrderRequestDialog}
              shareDataArr={filterShareData}
              isLocationTab={isLocationTab}
            />
          )}
          <ShareData
            attachDocumentHandler={attachDocumentHandler}
            control={control}
            watch={watch}
            setValue={setValue}
            shareDataArr={shareDataArr}
            setShareDataArr={setShareDataArr}
            selectedChat={selectedChat}
            isLocationTab={isLocationTab}
            resetHandler={resetHandler}
          />
        </>
      </MainPageDialog>
    )
  );
};

export default React.memo(ShareDataFromSidePanel);
